
import { ActivityCodeApi } from "@/api/ActivityCodeApi";
import { ProviderApi } from "@/api/ProviderApi";
import { ProviderInvoiceCategoryApi } from "@/api/ProviderInvoiceCategoryApi";
import { SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { ATV_RESPONSES, PROVIDER_NOTE_TYPES, TAXES_CONDITIONS } from "@utils/Constants";

const ProviderInvoiceMessageFormonfig = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "providerId",
                        "label": "Provedor",
                        "optionsFunction": () => ProviderApi.optionsList(),
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 6
                        },
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "tipo",
                        "isHorizontal": true,
                        "validation": Yup.string().required(),
                        "label": "Tipo De Nota",
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 3
                            }
                        },
                        "options": PROVIDER_NOTE_TYPES,
                    }
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "mensaje",
                        "isHorizontal": true,
                        "validation": Yup.string().required(),
                        "label": "Mensaje Respuesta",
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 4
                            }
                        },
                        "options": ATV_RESPONSES,
                    }
                ],
                [
                    {
                        "type": "text",
                        "name": "detalle",
                        "isHorizontal": true,
                        "label": "Detalle",
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 8
                            }
                        },
                    }
                ],
                [
                    {
                        "type": "number",
                        "name": "numero",
                        "label": "Numero Factura",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 4
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "providerInvoiceCategoryId",
                        "label": "Categoria Compra",
                        "optionsFunction": () => ProviderInvoiceCategoryApi.optionsList(),
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "activitycode",
                        "isHorizontal": true,
                        "label": "Actividad Economica",
                        "optionsFunction": () => ActivityCodeApi.optionsList({}, undefined, "code"),
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 4
                            }
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "condicionImpuesto",
                        "isHorizontal": true,
                        "label": "Condicion Impuesto",
                        "options": TAXES_CONDITIONS,
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 5
                            }
                        }
                    },
                ],
                [
                    {
                        "type": "money",
                        "isDecimal": true,
                        "name": "impuestoAcreditar",
                        "label": "Monto Total Impuesto Acreditar",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "isDecimal": true,
                        "name": "gastoAplicable",
                        "label": "Monto Total de Gasto Aplicable",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
            ]
        }
    ],
};


export default ProviderInvoiceMessageFormonfig;